<ion-row
  *ngIf="(ingredients ?? []).length === 0"
  class="no-ingredients-container"
>
  <ng-container [ngTemplateOutlet]="noIngredients"></ng-container>
</ion-row>
<ion-row class="ingredientCard" *ngFor="let ingredient of ingredients">
  <ion-col size="12">
    <app-ingredients-card
      [cardData]="ingredient"
      [platform]="platform"
      [lockEdits]="lockEdits"
      (ellipsisEvent)="onEllipsisClick($event)"
      (costInfoIconEvent)="clickInfoIcon($event)"
      (nameClickEvent)="onNameClick($event)"
    >
    </app-ingredients-card>
  </ion-col>
</ion-row>

<ng-template #noIngredients>
  <div class="no-ingredients">
    <img
      src="assets/images/box-dimension-black.svg"
      class="box-dimension-image"
      alt="box-image"
    />
    <p>{{ 'i18n.menuProfitPro.recipeDetail.noIngredient' | translate }}</p>
    <ng-container [ngTemplateOutlet]="addIngredientsButton"></ng-container>
  </div>
</ng-template>

<ng-template #addIngredientsButton>
  <ion-button
    [class]="'usf-fill-green-button add-ing'"
    data-cy="recipe-page-add-ingredient-button"
    (click)="onAddIngredients()"
    [class.disabled]="lockEdits"
    [disabled]="lockEdits"
  >
    {{ 'i18n.menuProfitPro.recipeDetail.addIngredient' | translate }}
    <ion-icon
      data-cy="recipe-page-add-ingredient-button-icon"
      name="add-outline"
    ></ion-icon>
  </ion-button>
</ng-template>
